
const TrustBlock = () => {
  return (
    <div className="bg-white py-6 border-b border-gray-100">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12">
          <a 
            href="https://yandex.ru/maps" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center space-x-2 group cursor-pointer"
          >
            <div className="flex items-center">
              {[1, 2, 3, 4].map((star) => (
                <i key={star} className="ri-star-fill text-yellow-400 text-lg"></i>
              ))}
              <i className="ri-star-half-fill text-yellow-400 text-lg"></i>
            </div>
            <span className="font-open-sans text-sm text-gray-700 group-hover:text-[#1E88E5] transition-colors">
              <strong className="font-semibold">4,5</strong> на Яндекс
            </span>
          </a>

          <div className="flex items-center space-x-2">
            <div className="w-10 h-10 flex items-center justify-center bg-[#1E88E5]/10 rounded-full">
              <i className="ri-calendar-check-line text-[#1E88E5] text-xl"></i>
            </div>
            <span className="font-open-sans text-sm text-gray-700">
              Работаем <strong className="font-semibold">с 2011 года</strong>
            </span>
          </div>

          <div className="flex items-center space-x-2">
            <div className="w-10 h-10 flex items-center justify-center bg-[#27AE60]/10 rounded-full">
              <i className="ri-user-heart-line text-[#27AE60] text-xl"></i>
            </div>
            <span className="font-open-sans text-sm text-gray-700">
              <strong className="font-semibold">70%</strong> путешественников возвращаются
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustBlock;
